import React from 'react';
import { useFormikContext } from 'formik';
import { get } from 'lodash';

import Editor from '~/components/core/Editor';

const INSTRUCTIONS_DISPLAY_CONFIG = {
  textStyle: true,
  align: true,
  link: true,
  headings: true,
};

interface InstructionsMarkdownEditorFormikProps {
  id: string;
  containerClassName?: string;
}

const InstructionsMarkdownEditorFormik: React.FC<InstructionsMarkdownEditorFormikProps> = ({
  id,
  containerClassName,
}) => {
  const { values, setFieldValue } = useFormikContext<Record<string, unknown>>();
  const initial = get(values, id, '');
  return (
    <Editor
      content={typeof initial === 'string' ? initial : ''}
      displayConfig={INSTRUCTIONS_DISPLAY_CONFIG}
      saveAsMarkdown
      onChange={(markdown) => setFieldValue(id, markdown)}
      containerClassName={containerClassName}
    />
  );
};

export default InstructionsMarkdownEditorFormik;
